module.exports = __webpack_public_path__ + "./assets/headshot_jes.jpg";